import Vue from 'vue'

Vue.filter('currencySymbol', (value) => {
  if (value === undefined) {
    return ''
  }

  let a = 0

  return a.toLocaleString('en', { style: 'currency', currency: value }).replace(/\d+([,.]\d+)?/g, '')
})
